/**
 * Converter - Smooth scrolling for conversion results
 * @module Converter
 */
(function() {
    'use strict';

    /**
     * Initialize the converter page
     */
    function init() {
        // Smooth scroll to result on page load if result exists
        scrollToResultIfExists();
    }

    /**
     * Scroll to the conversion result if it exists
     */
    function scrollToResultIfExists() {
        const resultElement = document.getElementById('conversion-result');
        
        if (resultElement && typeof resultElement.scrollIntoView === 'function') {
            window.requestAnimationFrame(function() {
                resultElement.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'start' 
                });
            });
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
